/*=========================================================================================
  File Name: module-invoicefiles-actions.js
  Description: InvoiceFiles Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import httpClient from '../../api/axios-httpclient';
import InvoiceFilesAPI from '@/api/InvoiceFilesAPI.js';
import commonFunc from '@/common/commonFunction';
import EventBusGlobal, { GlobalEventName } from '@/sys/eventBusGlobal';
import { MSEnum } from '../../common/enumeration';
export default {
	getFileProccedById: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: InvoiceFilesAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/email/${payload}`
		});

		if (res && res.Success) {
			return res.Data;
		}
		return null;
	}
};
